// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import {
  changeStatusInvoice,
  createInvoice,
  getInvoiceDetails,
  getInvoiceList,
  sendInvoice,
} from './invoiceThunk';

export interface IInvoiceState {
  isRefreshInvoiceList: boolean;
  isRefreshInvoiceDetail: boolean;
}

export const initialState: IInvoiceState = {
  isRefreshInvoiceList: false,
  isRefreshInvoiceDetail: false,
};

const invoiceSlice = createSlice({
  name: 'invoice',
  initialState,
  reducers: {
    setRefreshInvoiceList: (state, action) => {
      state.isRefreshInvoiceList = action.payload;
    },
    setRefreshInvoiceDetail: (state, action) => {
      state.isRefreshInvoiceDetail = action.payload;
    },
  },
  extraReducers: (builder) => {
    // GET: Get list Invoice
    builder
      .addCase(getInvoiceList.pending, (state) => {})
      .addCase(getInvoiceList.fulfilled, (state) => {})
      .addCase(getInvoiceList.rejected, (state) => {});

    // POST: Create invoice
    builder
      .addCase(createInvoice.pending, (state) => {})
      .addCase(createInvoice.fulfilled, (state) => {})
      .addCase(createInvoice.rejected, (state) => {});

    // GET: Get invoice details
    builder
      .addCase(getInvoiceDetails.pending, (state) => {})
      .addCase(getInvoiceDetails.fulfilled, (state) => {})
      .addCase(getInvoiceDetails.rejected, (state) => {});

    // PUT: Change status invoice
    builder
      .addCase(changeStatusInvoice.pending, (state) => {})
      .addCase(changeStatusInvoice.fulfilled, (state) => {})
      .addCase(changeStatusInvoice.rejected, (state) => {});

    // PUT: Send invoice
    builder
      .addCase(sendInvoice.pending, (state) => {})
      .addCase(sendInvoice.fulfilled, (state) => {})
      .addCase(sendInvoice.rejected, (state) => {});
  },
});

// Action
export const invoiceActions = invoiceSlice.actions;

// Selectors
export const selectIsRefreshInvoiceList = (state: RootState) => state.invoice.isRefreshInvoiceList;
export const selectIsRefreshInvoiceDetail = (state: RootState) => state.invoice.isRefreshInvoiceDetail;

// Reducer
const invoiceReducer = invoiceSlice.reducer;
export default invoiceReducer;
